import React from 'react';
import './SuccessRate.css';

interface SuccessRateProps {
  successRate: number;
  metrics?: {
    countPendingForSend: number;
    countReadyForSend: number;
  };
}

const SuccessRate: React.FC<SuccessRateProps> = ({ successRate, metrics }) => {
  const getSuccessRateClass = (rate: number) => {
    if (rate >= 80) return 'excellent';
    if (rate >= 60) return 'good';
    if (rate >= 40) return 'fair';
    if (rate >= 20) return 'poor';
    return 'critical';
  };

  const getSuccessRateColor = (rate: number) => {
    if (rate >= 80) return '#28a745'; // Verde
    if (rate >= 60) return '#6f42c1'; // Morado
    if (rate >= 40) return '#fd7e14'; // Naranja
    if (rate >= 20) return '#dc3545'; // Rojo
    return '#6c757d'; // Gris
  };

  if (!metrics) {
    return (
      <span className="success-rate no-data" title="Sin datos de métricas">
        N/A
      </span>
    );
  }

  return (
    <span 
      className={`success-rate ${getSuccessRateClass(successRate)}`}
      style={{ color: getSuccessRateColor(successRate) }}
      title={`SUCCESS RATE: ${successRate}% (${metrics.countReadyForSend}/${metrics.countPendingForSend})`}
    >
      {successRate}%
    </span>
  );
};

export default SuccessRate;
